export const getSection = (store) => store.questionnaire.section;
export const getQuestion = (store) => store.questionnaire.question;
export const getInfo = (store) => store.hoverInfo;
export const quizDone = (store) => store.quizDone;
export const getSelection = (store) => store.landing;
export const getTab = (store) => store.research;
